package game.ui;

import cerastes.pass.SubtractionFilter.SubtractionShader;
import data.Parts;
import cerastes.LocalizationManager;
import cerastes.LocalizationManager.LocalizedString;
import hxd.Key;
import data.Parts.ConsoleMfg;
import data.Parts.ConsoleType;
import cerastes.ui.AdvancedText;
import h2d.Object;
import cerastes.SoundManager;
import cerastes.Utils;
import cerastes.fmt.CUIResource.CUIEntity;
import cerastes.c2d.Vec2;
import h2d.Interactive;
import cerastes.ui.Button;
import cerastes.fmt.CUIResource.CUIObject;
import cerastes.ui.UIEntity;
#if tools
import cerastes.tools.ImguiTool.ImGuiToolManager;
import imgui.ImGuiMacro.wref;
import imgui.ImGui;
import cerastes.tools.ImguiTools.IG;
#end

@:structInit class UIBBSDef extends CUIObject
{
}

@:build(cerastes.macros.Callbacks.CallbackGenerator.build())
@:build(cerastes.macros.UIEntityBuilder.build( UIBBSDef ))
class UIBBS extends UIEntity
{
	#if tools
	@:keep public static function getInspector( def: UIBBSDef ) {
	}
	#end

	var colorFG = "dba939";
	var colorBG = "361101";
	var colorHighlight = "b94403";

	@:obj public var txtMain: AdvancedText;


	@:callbackStatic
	public static function onClosed();
	@:callbackStatic
	public static function onOpened();

	var textTimer: Float;
	var mfg: ConsoleMfg = Invalid;
	var console: ConsoleType = Invalid;
	
	var keyMap: Map<Int, Void->Void> = [];

	var partsPage: Int = 0;


	public override function initialize( root: h2d.Object )
	{
		//removeChildren();
		//root = hxd.Res.ui.part_slot.toObject(this);

		cerastes.macros.UIPopulator.populateObjects();
		super.initialize(root);

		visible = false;
	}

	override function tick( d: Float )
	{
		if( txtMain == null )
			return;

		if( txtMain.characters < txtMain.textLength )
		{
			textTimer += d;
			var textSpeed = 0.003;

			while( textTimer > textSpeed )
			{
				txtMain.characters++;
				textTimer -= textSpeed;
			}
		}

		for( key => val in keyMap )
		{
			if( Key.isPressed( key ) )
			{
				keyMap[key]();
			}
		}

	}

	public function show()
	{
		visible = true;
		runTimeline( "appear" );
		showHomePage();
		onOpened();
	}

	function box2(text: String, width: Int)
	{
		text = '░▒▓★${colorFG}☃${colorBG}${text}★☃▓▒░';
		var textWidth = cleanText(text).length;
		var paddingLeft: Int = Math.floor( ( ( width - 2 ) - textWidth ) / 2);
		var paddingRight: Int = width - (2 + paddingLeft + textWidth + 1);
		paddingRight++;

		var sb = new StringBuf(); 

		sb.add('╔');
		for( i in 0 ... width - 2)
			sb.add('═');
		sb.add('╗');
		sb.add('\n');
		sb.add('║');
		//sb.add('★${colorFG}☃${colorBG}');
		
		for( i in 0 ... paddingLeft)
			sb.add(' '); 
		sb.add(text);
		for( i in 0 ... paddingRight)
			sb.add(' '); 

		//		sb.add('★☃');

		sb.add('║\n');

		
		sb.add('╚');

		for( i in 0 ... width - 2)
			sb.add('═');
		sb.add('╝');
		
		sb.add('\n');
		//╔═╗
		//╟»║
		//╚═╝

		return sb.toString();
	}



	function pageHeader(text: LocalizedString)
	{
		txtMain.characters = 0;
		/*
		txtMain.text  = '=============\n';
		txtMain.text += '>> ★FFFFFF☃000000 $text ☃★ \n';
		txtMain.text += '=============\n';
		*/
		txtMain.text = box2(text, 40);
	}

	function menuBegin(header: LocalizedString, width: Int = 20)
	{
		keyMap= [];
		
		// Always let you "e" to
		keyMap.set(Key.E, exitPage);
		
		var text = header.get();
		var textWidth = cleanText(text).length;
		var tail = width - (1 + textWidth + 2 + 1);

		var sb = new StringBuf(); 
		sb.add('┌');
		sb.add('★${colorFG}☃${colorBG} ${text} ★☃');
		for(i in 0 ... tail)
			sb.add('─');
		sb.add('┐\n');

		txtMain.text += sb.toString();

		
	}
	function menuEnd( width: Int = 20 )
	{
		var sb = new StringBuf(); 
		sb.add('└');
		
		for(i in 0 ... width-2)
			sb.add('─');
		sb.add('┘\n');

		txtMain.text += sb.toString();
	}

	function cleanText(text: String )
	{
		var r = ~/☃[A-z0-9]{6}(.*)☃/gm;
		text = r.replace(text,"$1");

		var r = ~/★[A-z0-9]{6}(.*)★/gm;
		text = r.replace(text,"$1");

		return text;
	}

	function menuOpt( label: LocalizedString, key: Int, onPress: Void -> Void, width: Int = 20 )
	{
		var text = label.get();

		var sb = new StringBuf(); 
		var rpad = width - (cleanText(text).length + 3);
		sb.add( '├╴${label}' );
		for(i in 0 ... rpad )
			sb.add(' ');

		sb.add('│\n');
		keyMap[key] = onPress;
		txtMain.text += sb.toString();
	}

	function textBlock(header: LocalizedString, text: String )
	{
		addText( '▟★${colorFG}☃${colorBG}${header}★☃▛ ${text}');
	}

	function addText(text: String)
	{
		var sb = new StringBuf(); 
		/*do 
		{
			var lf = text.indexOf('\n');
			if( lf > 0 && lf <= 40 )
			{
				sb.add( text.substr(0,lf+1) );
				text = text.substr(lf+1);
				continue;
			}
			if( text.length == 0 )
				break;

			if( text.length <= 40 )
			{
				sb.add('$text\n');
				break;
			}
			var cpos = text.lastIndexOf(' ', 40);
			if( cpos <= 0 )
			{
				sb.add('$text\n');
				break;
			}
			cpos++;
			var cut = text.substr(0,cpos);
			text = text.substr(cpos);
			sb.add('$cut\n');
		}
		while( text.length > 0);
		*/
		sb.add(text);
		sb.add('\n');

		txtMain.text += sb.toString();
	}

	function exitPage()
	{
		var t = createTimelineRunner( "disappear" );
		t.onComplete =  () -> {
			this.visible = false;
		};
		t.play();
		onClosed();
	}

	function showHomePage()
	{
		keyMap = [];

		pageHeader("bbs_home_header");
		addText( LocalizationManager.localize("bbs_home_blurb") );
		menuBegin("NAV");
		menuOpt('☃${colorHighlight}P☃arts', Key.P, showPartsPage );
		menuOpt('☃${colorHighlight}E☃xit', Key.E, exitPage );
		menuEnd();
	}
	

	function showPartsPage()
	{
		partsPage = 0;
		pageHeader("bbs_parts_header");
		addText( LocalizationManager.localize("bbs_parts_blurb") );
		menuBegin("bbs_mfg_header");
		menuOpt('☃${colorHighlight}M☃illenium Makina', Key.M, () -> { showParts(MilleniumMakina ); } );
		menuOpt('☃${colorHighlight}A☃liceNet', Key.A, () -> { showParts(Alicenet ); } );
		menuOpt('☃${colorHighlight}C☃ALICOMP', Key.C, () -> { showParts(CALICOMP ); }  );
		menuOpt('☃${colorHighlight}Z☃enon', Key.Z, () -> { showParts(Zenon ); }  );
		menuOpt('☃${colorHighlight}B☃ack', Key.B, showHomePage  );
		menuEnd();
	}

	function highlightText(text: String)
	{
		return '☃${colorHighlight}${text}☃';
	}

	function showParts( mfg: ConsoleMfg )
	{
		pageHeader(LocalizationManager.localize('company_${mfg}'));

		var consoles = Parts.getConsolesByMfg(mfg);

		if( partsPage >= consoles.length )
		{
			textBlock( "Error", "404 not found" );

			menuBegin("bbs_nav_menu");
			menuOpt('☃${colorHighlight}B☃ack', Key.B, showPartsPage );
			menuEnd();
			
			return;

		}


		var console = consoles[partsPage];


		if( GameState.data.day == 1 && GameState.get("tutorial_phase") == 8 && console.console == data.Parts.ConsoleType.Alice68k )
		{
			GameState.flow.jumpFile("data/day1.flow", "repair_day1_3");
		}


		// Sunset
		var capPart = data.Parts.lookupConsolePart(Capacitor, console.console );
		var soundPart = data.Parts.lookupConsolePart(SoundChip, console.console );
		var procPart = data.Parts.lookupConsolePart(Processor, console.console );

		var key = 'bbs_parts_${console.console}';

		if( !LocalizationManager.exists( key ) )
			key = 'bbs_parts_generic';

		textBlock( 
			Parts.localizeConsoleType( console.console ),
				LocalizationManager.localize( key,
					highlightText(capPart.name), 
					highlightText(soundPart != null ? soundPart.name : "None"), 
					highlightText(procPart.name)
				)
			);

		menuBegin("bbs_nav_menu");
		if( consoles.length - 1 > partsPage )
			menuOpt('☃${colorHighlight}N☃ext', Key.N, () -> { partsPage++; showParts( mfg ); } );
		if( partsPage > 0 )
			menuOpt('☃${colorHighlight}B☃ack', Key.B, () -> { partsPage--;  showParts( mfg ); }  );
		else
			menuOpt('☃${colorHighlight}B☃ack', Key.B, showPartsPage );
		menuEnd();
	}

}